export const INITIAL_FAVOURITE_PRODUCT = 'INITIAL_FAVOURITE_PRODUCT'
export const ADD_FAVOURITE_PRODUCT = 'ADD_FAVOURITE_PRODUCT'
export const REMOVE_FAVOURITE_PRODUCT = 'REMOVE_FAVOURITE_PRODUCT'
export const SET_PRODUCT_PRICING = 'SET_PRODUCT_PRICING';
export const RESET_PRODUCT_PRICING = 'RESET_PRODUCT_PRICING';
